import React,{useState,useRef,useEffect} from 'react';
import {Button, Input, Space} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import '../index.css'
import {useSelector} from "react-redux";

function  GetColumnSearchProps(dataIndex,callback) {




  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const searchInput = useRef(null);



  const handleSearch = (selectedKeys, confirm, dataIndex) => {

    if(callback && selectedKeys.length<1){
      callback(true)
    }
    confirm();



    // setSearchText(selectedKeys[0]);
    // setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    // setSearchText('');
  };
  const getColumnSearchProps = (dataIndex
  ) => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
      <div
        style={{
          padding: 5,
           // marginTop:'10rem'
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`请输入关键字`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined/>}
            size="small"
            style={{
              width: "5rem",
            }}
          >
            搜索
          </Button>
          <Button
            onClick={() =>
              handleReset(clearFilters)
            }
            size="small"
            style={{
              width: "3rem",
            }}
          >
            重置
          </Button>
          {/*<Button*/}
          {/*  type="link"*/}
          {/*  size="small"*/}
          {/*  onClick={() => {*/}
          {/*    confirm({*/}
          {/*      closeDropdown: false,*/}
          {/*    });*/}
          {/*    setSearchText(selectedKeys[0]);*/}
          {/*    setSearchedColumn(dataIndex);*/}
          {/*  }}*/}
          {/*>*/}
          {/*  Filter*/}
          {/*</Button>*/}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          marginRight:'10px',
          left:'-20px',
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      const fieldValue = record[dataIndex];
      if (!fieldValue || fieldValue === 'undefined' || fieldValue === 'null') {
        return false;
      }
      return fieldValue.toString().toLowerCase().includes(value.toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    // render: (text) =>
    //   searchedColumn === dataIndex ? (
    //     <Highlighter
    //       highlightStyle={{
    //         backgroundColor: '#ffc069',
    //         padding: -1,
    //       }}
    //       searchWords={[searchText]}
    //       autoEscape
    //       textToHighlight={text ? text.toString() : ''}
    //     />
    //   ) : (
    //     text
    //   ),
  });
  return getColumnSearchProps(dataIndex);
}

export default GetColumnSearchProps;




